import { isBannerAdObject } from "../ads/adrequest";
function getTagsByLineitem(adResponses) {
    const roadblockCampaigns = new Map();
    const lineitemRegex = /window.en_container_id = "\d+\$(\d+)\$/;
    adResponses.forEach((adResponse) => {
        const { adObject } = adResponse;
        if (adObject) {
            if (isBannerAdObject(adObject)) {
                const match = adObject.banner.content.match(lineitemRegex);
                if (match) {
                    const entry = roadblockCampaigns.get(match[1]);
                    if (entry) {
                        roadblockCampaigns.set(match[1], [...entry, adObject.targetId]);
                    }
                    else {
                        roadblockCampaigns.set(match[1], [adObject.targetId]);
                    }
                }
            }
        }
    });
    return roadblockCampaigns;
}
function matchRoadblocks(configuredRoadblocks, lineitems) {
    const matchedRoadblocks = [];
    configuredRoadblocks.forEach((rb) => {
        const tags = [rb.primary, ...rb.secondaries].sort();
        lineitems.forEach((li) => {
            if (JSON.stringify(li.sort()) === JSON.stringify(tags)) {
                matchedRoadblocks.push(rb);
            }
        });
    });
    return matchedRoadblocks;
}
export { getTagsByLineitem, matchRoadblocks };
//# sourceMappingURL=roadblock.js.map